import styles from "./SetupHelpLink.module.scss"
import { usePolyglot } from "src/contexts"

const polyglotPrefix = "pages.alerts.contacts."

export function SetupHelpLink() {
  const polyglot = usePolyglot()
  return (
    <a
      className={styles.helpLink}
      id="getting-started"
      href="https://help.sugarmate.io/en/articles/4673352-setting-up-alerts"
      target="_blank"
      rel="noreferrer"
    >
      {polyglot.t(`${polyglotPrefix}help_link`)}
    </a>
  )
}
